export function reorderQuoteLineIds(ids: readonly string[], fromIndex: number, toIndex: number): string[] {
  if (fromIndex === toIndex) return [...ids];
  if (fromIndex < 0 || toIndex < 0 || fromIndex >= ids.length || toIndex >= ids.length) return [...ids];
  const next = [...ids];
  const [moved] = next.splice(fromIndex, 1);
  if (!moved) return [...ids];
  next.splice(toIndex, 0, moved);
  return next;
}
